/**
 * assets/support.js
 * Support page interactivity: FAQ category filter, accordion, contact form success state.
 * Loaded globally as type="module". No-op on non-support pages (guards on #support-faq-section).
 */

const CATEGORIES = [
  { id: 'charging', label: 'Charging & battery', count: 4 },
  { id: 'sizing',   label: 'Sizing & fit',        count: 3 },
  { id: 'presets',  label: 'Presets & controls',  count: 4 },
  { id: 'care',     label: 'Care & cleaning',      count: 3 },
  { id: 'shipping', label: 'Shipping & returns',   count: 4 },
  { id: 'warranty', label: 'Warranty',             count: 3 },
];

// Guard: no-op on non-support pages
if (document.getElementById('support-faq-section')) { initSupport(); }

function initSupport() {

  // ── Element refs ───────────────────────────────────────────────────
  const catButtons = document.querySelectorAll('.faq-cat');
  const faqItems   = document.querySelectorAll('.faq-item[data-category]');
  const headingEl  = document.getElementById('faq-heading');
  const countEl    = document.getElementById('faq-count');
  let openItem = null;

  // ── 1. Category filter ─────────────────────────────────────────────
  catButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const id  = btn.dataset.category;
      const cat = CATEGORIES.find(c => c.id === id);
      if (!cat) return;

      // Update active button
      catButtons.forEach(b => b.classList.toggle('faq-cat--active', b === btn));

      // Show matching FAQ items, hide others
      faqItems.forEach(item => {
        item.classList.toggle('faq-item--visible', item.dataset.category === id);
      });

      // Update heading + count
      if (headingEl) headingEl.textContent = cat.label;
      if (countEl)   countEl.textContent   = cat.count + ' common questions about this topic.';

      // Close any open accordion item
      if (openItem) { closeAccordion(openItem); openItem = null; }
    });
  });

  // ── 2. Accordion ───────────────────────────────────────────────────
  faqItems.forEach(item => {
    const trigger = item.querySelector('.faq-item__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      // Close previously open item
      if (openItem && openItem !== item) { closeAccordion(openItem); }

      if (isOpen) {
        closeAccordion(item);
        openItem = null;
      } else {
        openAccordion(item);
        openItem = item;
      }
    });
  });

  function openAccordion(item) {
    const trigger = item.querySelector('.faq-item__trigger');
    const body    = item.querySelector('.faq-item__body');
    const icon    = item.querySelector('.faq-item__icon');
    trigger.setAttribute('aria-expanded', 'true');
    body?.classList.add('faq-item__body--open');
    icon?.classList.add('faq-item__icon--open');
  }

  function closeAccordion(item) {
    const trigger = item.querySelector('.faq-item__trigger');
    const body    = item.querySelector('.faq-item__body');
    const icon    = item.querySelector('.faq-item__icon');
    trigger.setAttribute('aria-expanded', 'false');
    body?.classList.remove('faq-item__body--open');
    icon?.classList.remove('faq-item__icon--open');
  }

  // ── 3. Contact form success state ──────────────────────────────────
  // Shopify's {% form 'contact' %} does a full-page redirect on success,
  // appending ?contact%5Bsubmit%5D=1 to the current URL.
  if (new URLSearchParams(location.search).get('contact[submit]') === '1') {
    const btn = document.getElementById('contact-submit-btn');
    if (btn) {
      btn.textContent = '\u2713 Sent \u2014 we\u2019ll be in touch';
      btn.disabled = true;
    }
  }

} // end initSupport()
